import { useCallback, useEffect, useState } from "react";

const STORAGE_PREFIX = "day_notes_v1_";

export type DayNotesMap = Record<string, string>;

export interface UseDayNotesResult {
  notes: DayNotesMap;
  setNote: (date: string, text: string) => void;
}

export function useDayNotes(adAccountId: string | null | undefined): UseDayNotesResult {
  const storageKey = adAccountId ? `${STORAGE_PREFIX}${adAccountId}` : null;
  const [notes, setNotes] = useState<DayNotesMap>({});

  useEffect(() => {
    if (!storageKey) {
      setNotes({});
      return;
    }
    try {
      const raw = localStorage.getItem(storageKey);
      setNotes(raw ? (JSON.parse(raw) as DayNotesMap) : {});
    } catch {
      setNotes({});
    }
  }, [storageKey]);

  const setNote = useCallback(
    (date: string, text: string) => {
      if (!storageKey) return;
      setNotes((prev) => {
        const next: DayNotesMap = { ...prev };
        const trimmed = text.trim();
        if (trimmed) {
          next[date] = trimmed;
        } else {
          delete next[date];
        }
        try {
          localStorage.setItem(storageKey, JSON.stringify(next));
        } catch {
          // ignore quota / serialization errors — UI keeps in-memory state
        }
        return next;
      });
    },
    [storageKey]
  );

  return { notes, setNote };
}
